"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports._LogFrontendError = _LogFrontendError;
var infrastructure_const_1 = require("@src/const/infrastructure.const");
var backend_services_1 = require("./backend-services");
var MAX_DEPTH = 8;
var MAX_ARRAY_ITEMS = 50;
var MAX_STRING_LENGTH = 4000;
function _LogFrontendError(error_1) {
    return __awaiter(this, arguments, void 0, function (error, level) {
        var e_1;
        if (level === void 0) { level = 'error'; }
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, (0, backend_services_1.betterFetch)(infrastructure_const_1._CloudFunctions.fms + '/log-frontend-error', {
                            headers: { 'Content-Type': 'application/json' },
                            method: 'POST',
                            body: JSON.stringify({
                                level: level,
                                error: serializeForBackend(error),
                            }),
                        })];
                case 1:
                    _a.sent();
                    return [3 /*break*/, 3];
                case 2:
                    e_1 = _a.sent();
                    console.error('failed sending frontend error to backend', e_1);
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    });
}
function serializeForBackend(value, seen, depth) {
    if (seen === void 0) { seen = []; }
    if (depth === void 0) { depth = 0; }
    if (depth > MAX_DEPTH)
        return '[Max depth reached]';
    if (value === undefined)
        return '[undefined]';
    if (value === null)
        return null;
    var valueType = typeof value;
    if (valueType === 'string')
        return limitString(value);
    if (valueType === 'number')
        return isFinite(value) ? value : String(value);
    if (valueType === 'boolean')
        return value;
    if (valueType === 'bigint' || valueType === 'symbol')
        return String(value);
    if (valueType === 'function')
        return '[Function]';
    if (valueType !== 'object')
        return String(value);
    if (seen.indexOf(value) >= 0)
        return '[Circular]';
    seen.push(value);
    if (value instanceof Error) {
        var serializedError = {
            name: value.name,
            message: value.message,
            stack: value.stack,
        };
        var errorWithCause = value;
        if ('cause' in errorWithCause) {
            serializedError.cause = serializeForBackend(errorWithCause.cause, seen, depth + 1);
        }
        copyEnumerableProperties(value, serializedError, seen, depth);
        seen.pop();
        return serializedError;
    }
    if (Array.isArray(value)) {
        var serializedArray = value.slice(0, MAX_ARRAY_ITEMS).map(function (item) { return serializeForBackend(item, seen, depth + 1); });
        if (value.length > MAX_ARRAY_ITEMS) {
            serializedArray.push("[".concat(value.length - MAX_ARRAY_ITEMS, " more items]"));
        }
        seen.pop();
        return serializedArray;
    }
    var serializedObject = {};
    copyEnumerableProperties(value, serializedObject, seen, depth);
    seen.pop();
    return serializedObject;
}
function copyEnumerableProperties(value, target, seen, depth) {
    Object.keys(value).forEach(function (key) {
        try {
            target[key] = serializeForBackend(value[key], seen, depth + 1);
        }
        catch (_a) {
            target[key] = '[Unreadable property]';
        }
    });
}
function limitString(value) {
    if (value.length <= MAX_STRING_LENGTH)
        return value;
    return value.slice(0, MAX_STRING_LENGTH) + "...[".concat(value.length - MAX_STRING_LENGTH, " more characters]");
}
